/**
 * Checkbox Component - Component Definition
 * =========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { CheckboxController } from './controller';
import { CHECKBOX_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, CHECK_ICON, UNCHECK_ICON, DEFAULTS, CheckboxSize } from './constants';

export interface ICheckboxComponentBindings {
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  size?: CheckboxSize;
  inputId?: string;
  onChange?: (args: { checked: boolean }) => void;
}

export const checkboxComponentDefinition: IComponentOptions = {
  template: CHECKBOX_TEMPLATE,
  controller: CheckboxController,
  require: { ngModelCtrl: '?ngModel' },
  // Slot nombrado: <ec-label> dentro del componente.
  transclude: { labelSlot: '?ecLabel' },
  bindings: {
    label: '@',
    ariaLabel: '@',
    disabled: '<',
    size: '@',
    inputId: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.checkbox';

const checkboxModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecCheckbox', checkboxComponentDefinition);

export { CheckboxController, CHECKBOX_TEMPLATE, SIZES, BASE_CLASSES, CHECK_ICON, UNCHECK_ICON, DEFAULTS };
export type { CheckboxSize } from './constants';
export default checkboxModule;
